import { brand, surface } from './tokens';

// Values live in ./tokens (FE-1 / D9); this keeps the reviewDesk shape for
// its StyleSheet consumers.
export const reviewDesk = {
  canvas: surface.canvas,
  canvasMuted: surface.canvasMuted,
  card: surface.card,
  cardMuted: surface.cardMuted,
  ink: surface.ink,
  inkSoft: surface.inkSoft,
  muted: surface.muted,
  line: surface.line,
  lineStrong: surface.lineStrong,
  accent: brand.primary,
  accentSoft: brand.primarySoft,
  accentWash: brand.primaryWash,
  amber: surface.amber,
  amberSoft: surface.amberSoft,
  success: surface.success,
  successSoft: surface.successSoft,
  shadow: surface.shadow,
} as const;

export type ReviewDeskTheme = typeof reviewDesk;
